import PropTypes from 'prop-types';
import UserProp from '../../../commonComponents/propTypes/userProp';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import {
  LEAD_CONDITIONS,
  LEAD_STATUSES,
} from '../../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string,
  game: PropTypes.string,
  user: PropTypes.shape(UserProp.propType),
  owner: PropTypes.shape(UserProp.propType),
  status: PropTypes.oneOf(LEAD_STATUSES),
  condition: PropTypes.oneOf(LEAD_CONDITIONS),
  company: PropTypes.string,
  image: PropTypes.shape(ImageProp.propType),
  country: PropTypes.shape(CountryProp.propType),
  endDate: PropTypes.number,
};

export default { propType };
